(function () {
  var STORAGE_KEY = 'fc-bundle-selection';
  var bundleBlocks = document.querySelectorAll('.pdp-bundle__block');
  var variantAccordions = function () { return document.querySelectorAll('.variant-accordion'); };

  /* ── Parse bundle variant JSON data ── */

  var bundleVariantsData = {};
  (function loadVariantsData() {
    var scriptEl = document.querySelector('[data-bundle-variants-json]');
    if (!scriptEl) return;
    try {
      bundleVariantsData = JSON.parse(scriptEl.textContent);
    } catch (e) { /* invalid JSON */ }
  })();

  function getActiveBundleOption() {
    var active = document.querySelector('.pdp-bundle__block.active');
    return active ? active.getAttribute('data-bundle-option') : null;
  }

  function syncVariantAccordions() {
    var option = getActiveBundleOption();
    variantAccordions().forEach(function (accordion) {
      if (accordion.closest('[data-bundle-pop]')) return;
      if (option === 'single') {
        accordion.classList.remove('variant-accordion--collapsed');
      } else if (option === 'bundle') {
        accordion.classList.add('variant-accordion--collapsed');
      }
    });
  }

  /* ── Resolve selected options to a variant ── */

  function getSelectedOptionsForCard(productId) {
    var cardInfo = document.querySelector('[data-bundle-card-info][data-for-product="' + productId + '"]');
    if (!cardInfo) return [];

    var optionFields = cardInfo.querySelectorAll('[data-bundle-pop-option]');
    var selected = [];
    optionFields.forEach(function (field) {
      var checkedInput = field.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        selected.push(checkedInput.value);
      }
    });
    return selected;
  }

  function findMatchingVariant(bundleProductId, selectedOptions) {
    var productData = bundleVariantsData[bundleProductId];
    if (!productData || !productData.variants) return null;
    if (!selectedOptions.length) return productData.variants[0] || null;

    for (var i = 0; i < productData.variants.length; i++) {
      var variant = productData.variants[i];
      var match = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (!variant.options[j] || variant.options[j] !== selectedOptions[j]) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }
    return null;
  }

  /* ── localStorage helpers ── */

  function saveBundleSelection(card) {
    var productId = card.dataset.bundleProductId;
    var selectedOptions = getSelectedOptionsForCard(productId);
    var matchedVariant = findMatchingVariant(productId, selectedOptions);

    var data = {
      title: card.dataset.bundleTitle,
      bundleId: productId,
      bundleProductId: productId,
      bundleVariantId: matchedVariant ? String(matchedVariant.id) : card.dataset.bundleVariantId,
      bundleVariantTitle: matchedVariant ? matchedVariant.title : card.dataset.bundleTitle,
      bundleVariantPrice: matchedVariant ? String(matchedVariant.price) : card.dataset.bundleVariantPrice,
      bundleCategory: card.dataset.bundleCategory || '',
      selectedOptions: selectedOptions,
      mainProductId: document.querySelector('[data-bundle-pop]')?.dataset.mainProductId || ''
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* storage full or unavailable */ }
    return data;
  }

  function getSavedBundle() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function clearSavedBundle() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
  }

  /* ── Update bundle prices when the selected bundle product changes ── */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateBundlePrices(bundleVariantPrice) {
    var bundleBlock = document.querySelector('.pdp-bundle__block--bundle');
    if (!bundleBlock) return;

    var mainPrice = parseInt(bundleBlock.dataset.mainPrice, 10) || 0;
    var discountPct = parseInt(bundleBlock.dataset.bundleDiscountPct, 10) || 0;
    var bundlePrice = parseInt(bundleVariantPrice, 10) || 0;

    var combinedOriginal = mainPrice + bundlePrice;
    var combinedSale = combinedOriginal;
    var hasDiscount = discountPct > 0;

    if (hasDiscount) {
      combinedSale = combinedOriginal - Math.round(combinedOriginal * discountPct / 100);
    }

    var priceWrapper = bundleBlock.querySelector('[data-bundle-price-wrapper]');
    var regularEl = bundleBlock.querySelector('[data-bundle-price-regular]');
    var saleContainer = bundleBlock.querySelector('[data-bundle-price-sale]');
    var compareEl = bundleBlock.querySelector('[data-bundle-price-compare]');
    var finalEl = bundleBlock.querySelector('[data-bundle-price-final]');

    if (regularEl) {
      regularEl.textContent = formatMoney(combinedOriginal);
    }

    if (hasDiscount && priceWrapper) {
      priceWrapper.classList.add('price--on-sale');
      if (compareEl) compareEl.textContent = formatMoney(combinedOriginal);
      if (finalEl) finalEl.textContent = formatMoney(combinedSale);
      if (saleContainer) saleContainer.style.display = '';
    }
  }

  /* ── Update the bundle preview thumbnail in the bundle-and-save section ── */

  function updateBundlePreview(data) {
    var previewWrapper = document.querySelector('[data-bundle-preview]');
    if (!previewWrapper) return;

    var previewImg = previewWrapper.querySelector('[data-bundle-preview-image]');
    if (previewImg) {
      var matchedVariant = findMatchingVariant(data.bundleProductId, data.selectedOptions || []);
      if (matchedVariant && matchedVariant.featured_image) {
        previewImg.src = matchedVariant.featured_image;
        previewImg.alt = data.bundleVariantTitle || data.title;
      } else {
        var matchingCard = document.querySelector('[data-bundle-card][data-bundle-product-id="' + data.bundleProductId + '"]');
        if (matchingCard) {
          var img = matchingCard.querySelector('.pdp-bundle-pop__card-image img');
          if (img) {
            previewImg.src = img.src;
            previewImg.alt = data.title;
          }
        }
      }
    }

    var nameEl = previewWrapper.querySelector('[data-bundle-preview-name]');
    if (nameEl) {
      nameEl.textContent = data.bundleCategory;
    }
  }

  /* ── Mobile helpers ── */

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function updateMobileDetail(tab) {
    if (!tab) return;
    var activeCard = tab.querySelector('.pdp-bundle-pop__card.active');
    if (!activeCard) return;

    var productId = activeCard.dataset.bundleProductId;
    var mobileDetail = tab.querySelector('.pdp-bundle-pop__mobile-detail');
    if (!mobileDetail) return;

    /* Update title */
    var titleEl = mobileDetail.querySelector('[data-bundle-active-title]');
    if (titleEl) titleEl.textContent = (activeCard.dataset.bundleTitle || '').split(' |')[0];

    /* Move swatches: return previous, move new */
    var swatchArea = mobileDetail.querySelector('[data-bundle-active-swatches]');
    if (!swatchArea) return;

    var prevInfo = swatchArea.querySelector('[data-bundle-card-info]');
    if (prevInfo) {
      var prevCard = tab.querySelector('[data-bundle-card][data-bundle-product-id="' + prevInfo.dataset.forProduct + '"]');
      if (prevCard) prevCard.appendChild(prevInfo);
    }

    var activeInfo = activeCard.querySelector('[data-bundle-card-info]');
    if (activeInfo) {
      swatchArea.appendChild(activeInfo);
    }
  }

  function returnMobileSwatches() {
    var pop = document.querySelector('[data-bundle-pop]');
    if (!pop) return;
    pop.querySelectorAll('[data-bundle-active-swatches] [data-bundle-card-info]').forEach(function (info) {
      var card = pop.querySelector('[data-bundle-card][data-bundle-product-id="' + info.dataset.forProduct + '"]');
      if (card) card.appendChild(info);
    });
  }

  function initScrollProgress(tab) {
    if (!tab) return;
    var slider = tab.querySelector('[data-bundle-cards]');
    var progressBar = tab.querySelector('[data-bundle-scroll-bar]');
    if (!slider || !progressBar) return;

    function updateProgress() {
      var scrollWidth = slider.scrollWidth;
      var clientWidth = slider.clientWidth;
      var maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 0) {
        progressBar.style.width = '100%';
        progressBar.style.left = '0';
        return;
      }
      var ratio = clientWidth / scrollWidth;
      var barWidth = ratio * 100;
      var scrollPercent = maxScroll > 0 ? slider.scrollLeft / maxScroll : 0;
      var barLeft = scrollPercent * (100 - barWidth);
      progressBar.style.width = barWidth + '%';
      progressBar.style.left = barLeft + '%';
    }

    slider.removeEventListener('scroll', slider._fcScrollHandler);
    slider._fcScrollHandler = updateProgress;
    slider.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  /* ── Tab switching ── */

  function switchTab(targetTab) {
    var pop = document.querySelector('[data-bundle-pop]');
    if (!pop) return;

    /* Update toggle options */
    pop.querySelectorAll('[data-bundle-toggle-option]').forEach(function (opt) {
      opt.classList.toggle('active', opt.dataset.bundleToggleOption === targetTab);
    });

    /* Update toggle switch knob */
    var toggleSwitch = pop.querySelector('[data-bundle-toggle-switch]');
    if (toggleSwitch) {
      toggleSwitch.classList.toggle('unwind', targetTab === 'unwind');
    }

    /* Switch tabs */
    pop.querySelectorAll('[data-bundle-tab-content]').forEach(function (tab) {
      tab.classList.toggle('active', tab.dataset.bundleTabContent === targetTab);
    });

    /* Init mobile detail for the new tab */
    var activeTab = pop.querySelector('[data-bundle-tab-content="' + targetTab + '"]');
    if (activeTab && isMobile()) {
      updateMobileDetail(activeTab);
      initScrollProgress(activeTab);
    }
  }

  /* ── Expose bundle data globally for product-form.js ── */

  window.fcBundleSelection = {
    isActive: function () {
      return getActiveBundleOption() === 'bundle';
    },
    getData: function () {
      return getSavedBundle();
    },
    clear: function () {
      clearSavedBundle();
    }
  };

  /* ── Bundle block toggle (one pair / two pairs) ── */

  bundleBlocks.forEach(function (block) {
    block.addEventListener('click', function () {
      if (this.classList.contains('active')) return;
      bundleBlocks.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      syncVariantAccordions();
    });
  });

  /* ── Bundle pop (popup) logic ── */

  (function bindBundlePop() {
    function getPopEls() {
      var pop = document.querySelector('[data-bundle-pop]');
      var backdrop = document.querySelector('[data-bundle-pop-backdrop]');
      return pop && backdrop ? { pop: pop, backdrop: backdrop } : null;
    }

    var DURATION_MS = 500;
    var CLOSE_DURATION_MS = 400;
    var scrollLockPosition = { x: 0, y: 0 };

    function openPop() {
      var el = getPopEls();
      if (!el) return;
      scrollLockPosition.x = window.scrollX;
      scrollLockPosition.y = window.scrollY;
      el.pop.classList.remove('hidden');
      el.backdrop.classList.remove('hidden');
      document.body.classList.add('pdp-pop--is-active');
      el.backdrop.classList.add('active');
      el.pop.classList.add('active');
      el.pop.classList.add('pdp-bundle-pop--opening');
      setTimeout(function () {
        el.pop.classList.remove('pdp-bundle-pop--opening');
      }, DURATION_MS);

      /* Switch to opposite tab based on currently selected PDP variant group */
      var activeVariantItem = document.querySelector('.pdp-variants-group__item.active .pdp-variants-group__item-category');
      if (activeVariantItem) {
        var selectedCategory = activeVariantItem.textContent.trim().toLowerCase();
        if (selectedCategory === 'focus') {
          switchTab('unwind');
        } else if (selectedCategory === 'unwind') {
          switchTab('focus');
        }
      }

      /* Init mobile detail on open */
      if (isMobile()) {
        var activeTab = el.pop.querySelector('.pdp-bundle-pop__tab.active');
        if (activeTab) {
          updateMobileDetail(activeTab);
          initScrollProgress(activeTab);
        }
      }
    }

    function closePop() {
      var el = getPopEls();
      if (!el) return;

      /* Return mobile swatches before closing */
      returnMobileSwatches();

      el.pop.classList.add('pdp-bundle-pop--closing');
      el.backdrop.classList.remove('active');
      setTimeout(function () {
        el.pop.classList.remove('active', 'pdp-bundle-pop--closing');
        el.pop.classList.add('hidden');
        el.backdrop.classList.add('hidden');
        document.body.classList.remove('pdp-pop--is-active');
      }, CLOSE_DURATION_MS);
    }

    /* Open / Close */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-bundle-pop-open]')) {
        e.preventDefault();
        openPop();
      } else if (e.target.closest('[data-bundle-pop-close]')) {
        e.preventDefault();
        closePop();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var el = getPopEls();
      if (!el || !el.pop.classList.contains('active') || el.pop.classList.contains('pdp-bundle-pop--closing')) return;
      e.preventDefault();
      closePop();
    });

    /* Scroll lock */
    function isScrollLockActive() {
      var el = getPopEls();
      return el && el.pop.classList.contains('active') && !el.pop.classList.contains('pdp-bundle-pop--closing');
    }

    function onWheel(e) {
      if (!isScrollLockActive()) return;
      if (getPopEls().pop.contains(e.target)) return;
      e.preventDefault();
    }

    function onTouchMove(e) {
      if (!isScrollLockActive()) return;
      if (getPopEls().pop.contains(e.target)) return;
      e.preventDefault();
    }

    function onScroll() {
      if (!isScrollLockActive()) return;
      window.scrollTo(scrollLockPosition.x, scrollLockPosition.y);
    }

    document.addEventListener('wheel', onWheel, { passive: false });
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('scroll', onScroll, { passive: false });

    /* ── Resize handler — move swatches between mobile/desktop layout ── */
    var wasMobile = isMobile();
    window.addEventListener('resize', function () {
      var el = getPopEls();
      if (!el || !el.pop.classList.contains('active')) return;

      var nowMobile = isMobile();
      if (nowMobile === wasMobile) return;
      wasMobile = nowMobile;

      if (nowMobile) {
        var activeTab = el.pop.querySelector('.pdp-bundle-pop__tab.active');
        if (activeTab) {
          updateMobileDetail(activeTab);
          initScrollProgress(activeTab);
        }
      } else {
        returnMobileSwatches();
      }
    });

    /* ── Toggle switch ── */
    document.addEventListener('click', function (e) {
      var toggleSwitch = e.target.closest('[data-bundle-toggle-switch]');
      if (toggleSwitch) {
        e.preventDefault();
        var isUnwind = toggleSwitch.classList.contains('unwind');
        switchTab(isUnwind ? 'focus' : 'unwind');
        return;
      }

      var toggleOption = e.target.closest('[data-bundle-toggle-option]');
      if (toggleOption && !toggleOption.classList.contains('active')) {
        e.preventDefault();
        switchTab(toggleOption.dataset.bundleToggleOption);
      }
    });

    /* ── Card selection ── */
    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-bundle-card]');
      if (!card || !card.closest('[data-bundle-pop]')) return;
      if (e.target.closest('[data-bundle-pop-option]')) return;
      if (e.target.closest('input') || e.target.closest('label')) return;
      if (card.classList.contains('active')) return;

      var tab = card.closest('[data-bundle-tab-content]');
      if (!tab) return;

      tab.querySelectorAll('.pdp-bundle-pop__card').forEach(function (c) {
        c.classList.remove('active');
      });
      card.classList.add('active');

      if (isMobile()) {
        var slider = tab.querySelector('[data-bundle-cards]');
        if (slider) {
          var sliderRect = slider.getBoundingClientRect();
          var cardRect = card.getBoundingClientRect();
          if (cardRect.left < sliderRect.left || cardRect.right > sliderRect.right) {
            card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        }
        updateMobileDetail(tab);
      }
    });

    /* ── Swatch change — update variant data on card ── */
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (input.type !== 'radio' || !input.closest('[data-bundle-pop]')) return;
      if (!input.closest('[data-bundle-pop-option]')) return;

      var productId = input.dataset.bundleProductId;
      if (!productId) return;

      var card = document.querySelector('[data-bundle-card][data-bundle-product-id="' + productId + '"]');
      if (!card) return;

      var selectedOptions = getSelectedOptionsForCard(productId);
      var matchedVariant = findMatchingVariant(productId, selectedOptions);

      if (matchedVariant) {
        card.dataset.bundleVariantId = String(matchedVariant.id);
        card.dataset.bundleVariantPrice = String(matchedVariant.price);

        if (matchedVariant.featured_image) {
          var img = card.querySelector('.pdp-bundle-pop__card-image img');
          if (img) img.src = matchedVariant.featured_image;
        }
      }
    });

    /* ── "Add pair to bundle" button ── */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.pdp-bundle-pop__bundle-button')) return;

      var pop = document.querySelector('[data-bundle-pop]');
      if (!pop) return;

      var activeTab = pop.querySelector('.pdp-bundle-pop__tab.active');
      if (!activeTab) return;

      var activeCard = activeTab.querySelector('.pdp-bundle-pop__card.active');
      if (!activeCard) return;

      var data = saveBundleSelection(activeCard);
      updateBundlePreview(data);
      updateBundlePrices(data.bundleVariantPrice);

      /* Auto-activate the bundle block */
      var bundleBlock = document.querySelector('.pdp-bundle__block--bundle');
      if (bundleBlock && !bundleBlock.classList.contains('active')) {
        bundleBlocks.forEach(function (b) { b.classList.remove('active'); });
        bundleBlock.classList.add('active');
        syncVariantAccordions();
      }

      closePop();
    });
  })();

  /* ── Save default bundle so it's always available for add-to-cart ── */

  function saveDefaultBundle() {
    var pop = document.querySelector('[data-bundle-pop]');
    if (!pop) return;

    var activeTab = pop.querySelector('.pdp-bundle-pop__tab.active');
    if (!activeTab) return;

    var firstCard = activeTab.querySelector('.pdp-bundle-pop__card');
    if (!firstCard) return;

    var productId = firstCard.dataset.bundleProductId;
    var productData = bundleVariantsData[productId];
    var defaultVariant = productData && productData.variants ? productData.variants[0] : null;

    var data = {
      title: firstCard.dataset.bundleTitle || '',
      bundleId: productId,
      bundleProductId: productId,
      bundleVariantId: firstCard.dataset.bundleVariantId || (defaultVariant ? String(defaultVariant.id) : ''),
      bundleVariantTitle: defaultVariant ? defaultVariant.title : '',
      bundleVariantPrice: defaultVariant ? String(defaultVariant.price) : firstCard.dataset.bundleVariantPrice || '0',
      bundleCategory: firstCard.dataset.bundleCategory || '',
      selectedOptions: [],
      mainProductId: pop.dataset.mainProductId || ''
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* storage full or unavailable */ }
    return data;
  }

  /* ── On page load: restore saved bundle if it belongs to this product ── */

  (function restoreSavedBundle() {
    var saved = getSavedBundle();
    var pop = document.querySelector('[data-bundle-pop]');
    if (!pop) return;

    var mainProductId = pop.dataset.mainProductId;

    /* No saved data or different product — save the default */
    if (!saved || (saved.mainProductId && saved.mainProductId !== mainProductId)) {
      clearSavedBundle();
      saveDefaultBundle();
      return;
    }

    /* Find the matching card */
    var matchingCard = pop.querySelector('[data-bundle-card][data-bundle-product-id="' + saved.bundleProductId + '"]');
    if (matchingCard) {
      /* Activate the correct tab */
      var tab = matchingCard.closest('[data-bundle-tab-content]');
      if (tab) {
        switchTab(tab.dataset.bundleTabContent);
        tab.querySelectorAll('.pdp-bundle-pop__card').forEach(function (c) {
          c.classList.remove('active');
        });
        matchingCard.classList.add('active');
      }

      /* Restore swatch selections */
      if (saved.selectedOptions && saved.selectedOptions.length) {
        var cardInfo = pop.querySelector('[data-bundle-card-info][data-for-product="' + saved.bundleProductId + '"]');
        if (cardInfo) {
          var optionFields = cardInfo.querySelectorAll('[data-bundle-pop-option]');
          optionFields.forEach(function (field, index) {
            if (index >= saved.selectedOptions.length) return;
            var targetValue = saved.selectedOptions[index];
            var radios = field.querySelectorAll('input[type="radio"]');
            radios.forEach(function (radio) {
              if (radio.value === targetValue) {
                radio.checked = true;
              }
            });
          });
        }
      }
    }

    /* Update preview */
    updateBundlePreview(saved);

    /* Auto-activate bundle block */
    var bundleBlock = document.querySelector('.pdp-bundle__block--bundle');
    if (bundleBlock) {
      bundleBlocks.forEach(function (b) { b.classList.remove('active'); });
      bundleBlock.classList.add('active');
    }
  })();

  syncVariantAccordions();
})();
